var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      attrs: { "content-css": { minWidth: "60vw", minHeight: "95vh" } },
      on: { hide: _vm.onHide },
      model: {
        value: _vm.modalOpened,
        callback: function($$v) {
          _vm.modalOpened = $$v
        },
        expression: "modalOpened"
      }
    },
    [
      _c("i-q-form", {
        ref: "thisForm",
        on: { after: _vm.onAfter, submit: _vm.onSubmit, cancel: _vm.onCancel }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }